import { useRef } from 'react'

import { useIntersection } from 'react-use'

import { openNewWindow } from '@web/hooks/useGoTo'
import links from '@web/libs/constants/links'
import sendClickLog from '@web/libs/nlog/click/sendClickLog'
import { generatePath } from '@web/libs/utils'
import { ConvertedPlaceRecommend } from '@web/pages/v5/home/DdayRecommendPlacesSection'
import { ClickEvent } from '@web/types'

import styles from './RecommandPlacesSection.module.scss'
import ThumbnailContent from '../../ThumbnailContent'

interface Props {
  place: ConvertedPlaceRecommend
  clickCode: string
  rank: number
}

export const SlideImageCard = ({ place, clickCode, rank }: Props) => {
  const cardRef = useRef<any>(null)
  const { id, placeName, images, categoryName, reviewCountText, distanceText } = place
  const intersection = useIntersection(cardRef, { threshold: 0.75 })

  const subInfoTexts = [categoryName ? `${categoryName}` : null].filter(i => !!i) as string[]

  const handleClickImage = (e: ClickEvent) => {
    if (id) {
      sendClickLog({
        event: e,
        area: clickCode,
        rank,
        placeId: place.id,
      })
      openNewWindow(generatePath(links.PLACE_DETAIL, { placeId: id }))
    }
  }

  return (
    <ThumbnailContent
      item={{
        placeName: placeName,
        imageUrl: images?.[0],
        images: images?.slice(0, 3),
        subInfoTexts,
      }}
      isPaused={!intersection?.isIntersecting}
      onClick={handleClickImage}
      extra={reviewCountText && <div className={styles.label}>{`리뷰 ${reviewCountText}`}</div>}
    >
      {/* 거리정보 영역 */}
      {distanceText && (
        <div className={styles.distance_area} ref={cardRef}>
          예약장소로부터
          <em className={styles.distance}>{distanceText}</em>
        </div>
      )}
    </ThumbnailContent>
  )
}
